import { render } from "./ImarServiceCard.vue?vue&type=template&id=0a5ae252&scoped=true"
import script from "./ImarServiceCard.vue?vue&type=script&lang=js"
export * from "./ImarServiceCard.vue?vue&type=script&lang=js"

import "./ImarServiceCard.vue?vue&type=style&index=0&id=0a5ae252&lang=scss&scoped=true"
import "./ImarServiceCard.vue?vue&type=style&index=1&id=0a5ae252&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5ae252"]])

export default __exports__